/**
 * The "Skjult" marker on a row the viewer can see but nobody else can — a
 * post or comment a moderator hid, or one `approval_mode` is holding. It is
 * drawn wherever `isHidden` is rendered (feed card, comment row, the
 * moderation queue) so the one word looks the same in all three places and
 * a moderator has something to read "Vis igen" against (OSO-378).
 */
export function HiddenChip() {
  return (
    <span className="text-xs bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400 px-1.5 py-0.5 rounded shrink-0">
      Skjult
    </span>
  );
}
